// Hidden console location. Mirrors backend CONSOLE_BASE_PATH / CONSOLE_API_PREFIX.
// Kept in one place so moving to a subdomain later is a config change, not a refactor.
export const CONSOLE_PATH = "/ctrl-9x2k";       // frontend route
export const CONSOLE_API = "/ctrl-9x2k";        // relative to axios baseURL (/api)
